import ErrorOutline from '@mui/icons-material/ErrorOutline'
import { useQuery } from '@tanstack/react-query'
import { TModalIcon } from 'components/Shared/SydDialog/SydDialog'
import useDialog from 'hooks/Shared/useDialog'
import { selectErrorDialog } from 'lib/helpers/errors.helpers'
import { QueryOptions } from 'models/general'
import { IInvoice, CreditNote } from 'models/invoices.models'
import { getCreditNoteList } from 'services/Invoices/invoices.services'

const useCreditNoteList = (
  workspaceId: number,
  invoice?: IInvoice,
  options: QueryOptions<CreditNote[]> = {}
) => {
  // const dispatch = useDispatch();
  const dialog = useDialog()

  const {
    onBefore,
    onSuccess,
    onError,
    noDialog = false,
    refreshOn = [],
    ...rest
  } = options

  const query = useQuery<CreditNote[], any>(
    ['get-credit-note-list', workspaceId, invoice, ...refreshOn],
    () => {
      if (!invoice || !invoice.idCfdi)
        throw new Error('CFDI cargado incorrectamente')
      onBefore && onBefore()
      return getCreditNoteList(workspaceId, invoice.idCfdi)
    },
    {
      ...rest,
      onSuccess: data => {
        //!noSave && dispatch(setInvoicesList(data));
        onSuccess && onSuccess(data)
      },
      onError: async error => {
        const op = selectErrorDialog(error)
        if (op?.variant) {
          await dialog[op.variant](op)
          return
        }

        if (!noDialog) {
          const rp = await dialog.dangerAsync({
            title: 'generic.error.title',
            subtitle:
              'No se pudo obtener la lista de las notas de crédito para el CFDI seleccionado.',
            icon: ErrorOutline as TModalIcon,
            primaryButtonText: 'Reintentar',
            secondaryButtonText: 'Cancelar',
          })

          if (rp) {
            query.refetch()
            return
          }
        }

        onError && onError(error)
      },
    }
  )

  return query
}

export default useCreditNoteList
